module.exports = {
  vantText: {
    confirm: '确认',
    cancel: '取消',
  },
  center: {
    title: '主页',
    logout: '登出',
    coinDetail: '管理店铺',
    coinDetail1: '我的账单',
    coinTitle: '我的点数',
    recharge: '购买点数',
    cusservice: '我的客服',
    relativePhone: "更改电话号码",
    myintroPeople: "我的介绍人",
    myClient: "我的客户",
    platformList: '我的平台列表',
    platformInfo: '我的平台资料',
    chooseL: '语言',
    chooseLang: "请选择语言",
    message: '数据错误',
    tip: '注意: 只能有一个人登录',
    back: '退出',
    isBack: '是否退出登录',
  },
  ShopList: {
    title: '店铺管理',
    message: '数据错误',
    addshop: '添加店铺',
    add: '添加',
    enter: "进入",
    edit: '编辑',
    copy: "复制",
    delete: "删除",
    setting: "店铺设定",
    RechargeAmountSetting: "充值金额设定",
    addRechargeAmount: '添加充值金额',
  },
  member: {
    number: "序号",
    name: "名称",
    nameplaceholder: "请输入名称",
    PaymentAmount: "支付金额",
    RechargeAmount: "充值金额",
    Discount: '折扣',
    PaymentAmountplaceholder: "请输入支付金额",
    RechargeAmountplaceholder: "请输入充值金额",
    Discountplaceholder: '请输入折扣',
    Switch: "开关",
    order_number: "序号",
    order_numberPlaceholder: "请输入序号",
    Operate: "操作",
    ConfirmWhetherToDelete: "确认是否删除",
  },
  NewShop: {
    title: "设定店铺",
    name: "名称",
    address: "地址",
    pic: "图片",
    phone: "电话",
    startTime: "开店时间",
    chooseStartTime: "选择开店时间",
    endTime: "关门时间",
    chooseEndTime: "选择关门时间",
    timeLimit: "服务时限",
    cookTime: "制作时间",
    intro: "店铺介绍",
    chooseL: '店铺语言',
    inputIntro: "输入介绍",
    message: '数据错误',
    toast: '请填写完整信息',
    minute: '分钟',
    hour: '小时',
    shopType: '店铺类型',
    chooseShopType: '请选择店铺类型'
  },
  DishDetail: {
    title: "详情",
    specifications: '分量',
    tasteNotes: '口味/备注',
    message: '数据错误',
  },
  Dishes: {
    title: '请选择',
    noneGoods: '暂无产品',
    message: '数据错误',
    pachage: '套餐',
  },
  PackageDetail: {
    title: '详情',
    specifications: '分量',
    tasteNotes: '口味/备注',
    message: '数据错误',
    chooseSpecs: '选份量',
    note: '口味/备注',
    remark: '备注',
    inputRemark: "请输入备注",
    certain: '确定',
    addToCart: '加入购物车',
  },
  EditBook: {
    title: '预订',
    text: '门店未发布',
    codeText: '预订二维码',
    copy: '复制链接',
    refresh: '刷新二维码',
    copyBtn: '复制',
    refreshBtn: '刷新',
    message: '数据错误',
    bookSwitch: '预约显示',
    takeawaySwitch: '外送显示',
    menuSwitch: '菜单显示',
    pickSwitch: '打包显示',
  },
  EditDish: {
    title: "产品设置",
    category: '分类',
    noChoose: "若不选择,则隐藏",
    cookName: '主名称',
    enName: '副名称',
    inputName: "输入名称",
    pic: "图片",
    price: "价格",
    status: '单选',
    oldPrice: '原价',
    inputOldPrice: '输入原价',
    newPrice: '特价',
    inputNewPrice: "输入特价",
    commend: "推荐指数",
    prefer: "偏好设置",
    severce: "服务时长",
    intro: "介绍",
    inputIntro: "请输入产品介绍",
    noChoose1: '若不选择分类，则自动隐藏产品',
    message: '数据错误',
    toast: '请填写完整信息',
    ingredients: '产品',
    checkbox: "多选开关",
    DisplaySwitch: "显示开关",
    prompt: "不在同一分类内，排序无效"
  },
  EditPackage: {
    title: "套餐设置",
    packageName: "套餐名",
    enName: '副名称',
    inputPackageName: "输入套餐名",
    pic: '图片',
    price: "价钱",
    OldPrice: "填写原价",
    inputOldPrice: "输入原价",
    newPrice: "填写特价",
    inputNewPrice: "输入特价",
    commend: "推荐指数",
    intro: "介绍",
    inputIntro: "请输入套餐介绍",
    illustration: '说明',
    inputIllustration: '请输入说明',
    addCook: "添加产品种类",
    text: "请先添加套餐包含的分类，然后在分类里添加产品和设定差价",
    inputCategory: "请输入分类",
    message: '数据错误',
    pleaseInputName: '请填写名称。',
    toast: '请填写完整信息',
    delCategory: '删除分类',
    isDelCategory: '是否删除已选择的分类',
    chooseDelLabel: '请选择要删除的分类',
    chooseMoveLabel: '请选择要移动的分类'
  },
  EditShop: {
    title: "设定店铺",
    storeSetting: '店铺功能设定',
    name: "名称",
    inputName: "输入名称",
    address: "地址",
    inputAddress: "输入地址",
    pic: "店铺图片",
    advertising_images: "广告图片",
    phone: "电话",
    inputPhone: "输入联系电话",

    startTime: "开始营业时间",
    chooseStartTime: "选择开店时间",
    endTime: "结束营业时间",
    chooseEndTime: "选择结束营业时间",

    startAfterTime: "午休开始时间",
    chooseStartAfterTime: "选择午休开始时间",
    endAfterTime: "午休结束时间",
    chooseEndAfterTime: "选择午休结束时间",

    cookTime: "服务时限",
    cookingTime: "制作时间",
    intro: "店铺介绍",
    inputIntro: "输入介绍",
    message: '数据错误',
    toast: '请填写完整信息',
    minute: '分钟',
    chooseL: '店铺语言',
    currency: '店铺货币',
    chooseCurrency: '请选择货币',
    color: "店铺颜色选择",
    inputColor: "请选择颜色",

    fail_time: "外送超时时长",
    inputFail_time: "输入外送超时时长",
    isQuick: '快捷点单',
    isServiceCharge: '座位点餐-服务费',
    serviceCharge: '服务费',
    isDiscountFee: '座位点餐-折扣费',
    isFloat: '保留金额精度',
    isAdditional: '外送-地区附加费',
    amountExempt: '达成免除地区附加费的金额',
    amount: '请输入金额',
  },
  EditTable: {
    title: "区域人数设置",
    peopleNum: '人以上',
    num: '人',
    certain: '修改设置',
    certainBtn: '修改',
    copy: '点击复制链接',
    screenQRcode: '屏幕二维码',
    refresh: '点击刷新二维码',
    lineQRcode: '排队二维码',
    message: '数据错误',
    copyScuess: '复制成功',
    screenLink: "屏幕链接:"
  },
  MenuRank: {
    title: "产品排行",
    text1: '从',
    text: '至',
    price: "金额",
    rank: '排名',
    cookName: '名称',
    price1: '价格',
    num: '数量',
    money: "金额",
    portion: '份',
    portionNum: "份数",
  },
  NewDish: {
    title: "设定产品",
    cookName: '名称',
    inputName: "输入名称",
    pic: "图片",
    price: "价钱",
    oldPrice: "原价",
    inputOldPrice: "输入原价",
    newPrice: "特价",
    inputNewPrice: "输入特价",
    commend: "推荐指数",
    setPrefer: "偏好设置",
    category: "分类",
    message: '数据错误',
    toast: '请填写完整信息',
  },
  NewPackage: {
    title: "设定套餐",
    packageName: "套餐名",
    enName: '副名称',
    inputPackageName: "输入套餐名",
    pic: "图片",
    price: "价钱",
    oldPrice: "原价",
    inputOldPrice: "输入原价",
    newPrice: "特价",
    inputNewPrice: "输入特价",
    commend: "推荐指数",
    message: '数据错误',
    toast: '请填写完整信息',
  },
  NoData: {
    buy: '该功能需购买才能使用',
    noData: '暂无数据',
    sale: '请联系销售人员'
  },
  PackageDish: {
    title: '设置内容',
    chooseCook: '选择产品',
    compensationPrice: "补差价",
    inputMoney: "输入金额",
    cancel: "取消",
    cook: "产品",
    save: '保存',
    message: '数据错误',
    inputCompensationPrice: '请输入差价',
    pleaseChooseCook: '请选择产品',
    del: '删除',
    isDel: '是否删除已选择的产品',
    chooseDelCategory: '请选择要删除分类',
  },
  ServiceBill: {
    title: "我的账单",
    time: '时间',
    shopName: '店名',
    num: '已花点数',
    message: '数据错误',
    ActivateStore: '发布',
    RechargePoints: '充值'
  },
  SetMenu: {
    title: "产品列表设置",
    category: "分类",
    inputCategory: "请输入分类",
    prefer: "偏好",
    inputPrefer: "请输入偏好",
    cook: "产品",
    inputCookName: "请输入产品名",
    package: "套餐",
    inputPackageName: "请输入套餐名",
    show: "排序",
    name: "名称",
    showSwitch: "显示",
    perferSwitch: "多选",
    price: "价格",
    edit: "操作",
    message: '数据错误',
    toast: '请填写完整信息',
    del: '删除分量',
    isDel: '是否删除已选择的偏好',
    chooseDelCategory: '请选择要删除的选项',
    delCategory: '删除分类',
    isDelchooseCategory: '是否删除已选择的分类',
    delCook: '删除产品',
    isDelCook: '是否删除已选择的产品',
    delPackage: '删除套餐',
    isDelPackage: '是否删除已选择的套餐',
    batch: "批量绑定",
    Selected: "已选择",
    term: "项",
    batchClass: "批量绑定分类",
    batchPerfer: "批量绑定偏好",
    batchPrice: "批量绑定价格",
    batchClassTitle: "请选择批量绑定的分类",
    batchPerferTitle: "请选择批量绑定的偏好",
    batchPriceTitle: "请输入批量绑定的价格",
  },
  SetPerfer: {
    pleaseAdd: "请添加标签",
    message: '数据错误',
    toast: '请填写完整信息',
    del: '删除分量',
    isDel: '是否删除已选择的分量',
    chooseDelCategory: '请选择要删除的分类',
  },
  ShopStatus: {
    title: "店铺状态",
    publishsShop: '发布店铺',
    servicePoint: '点数余额',
    count: '点',
    cancel: '取消',
    certain: '确定',
    note: "注意事项",
    p1: '已购买的使用天数仅限于当前店铺使用。',
    p2: '天数一经购买无法撤回，因此购买后不接受退款，敬请理解。',
    p3: '删除当前店铺后，店铺剩余天数恕不退还，请谨慎操作。',
    p4: '最终解释权归本公司所有。',
    shopType: '店铺状态',
    inActive: '未发布',
    active: '已发布',
    canUse: '可使用',
    day: '天',
    message: '数据错误',
    shopOnLine: '发布店铺',
    text: '发布店铺将会扣除您',
    severceCount: '点数',
    InsufficientServicePoints: '您的点数不足'
  },
  ShopSet: {
    comment: "评论",
    deliveryTime: "交货时间",
    deliveryDate: "交货日期",
    PickUpDate: "取餐日期",
    PickUpTime: "取餐时间",
    title: "店功能",
    manage: "管理",
    set: "设定",
    report: "报表",
    statistical: "统计",
    editShop: "店铺管理",
    setMenu: "产品管理",
    setSeat: "座位管理",
    staffList: "员工管理",
    shopStatus: "激活状态",
    payEdit: "支付户口设定",
    paySet: "支付类型",
    phoneList: '客户资料', //电话号码列表
    cookPrinting: "后厨打印功能",
    ticketPrinting: "小票打印功能",
    cookInfo: "后厨功能",
    editTable: "排队功能",
    editBook: "店铺主页",
    monthReport: "月销售报表",
    weekReport: "周销售报表",
    dayReport: "日销售报表",
    customerTime: "客量报告",
    menuRank: "产品排行",
    tableRank: "桌位排行",
    staffReport: "员工报表",
    cookTime: "制作时间",
    publishsShop: '发布店铺',
    servicePoint: '点数余额',
    take_name: '收货人姓名',
    take_tel: '电话号码',
    take_address: '收货地址',
    is_show: '是否展示',
    is_write: '是否必填',
    is_print: '是否打印',
    count: '点',
    cancel: '取消',
    certain: '确定',
    note: "注意事项",
    p1: '已购买的使用天数仅限于当前店铺使用。',
    p2: '天数一经购买无法撤回，因此购买后不接受退款，敬请理解。',
    p3: '删除当前店铺后，店铺剩余天数恕不退还，请谨慎操作。',
    p4: '最终解释权归本公司所有。',
    inActive: '未发布',
    active: '已发布',
    canUse: '可使用',
    day: '天',
    message: '数据错误',
    del: '删除',
    isDelShop: '是否删除当前店铺？',
    shopOnLine: '发布店铺',
    text: '发布店铺将会扣除您',
    severceCount: '点数',
    InsufficientServicePoints: '您的点数不足',
    autoPrint: '自动打印开关',
    printerSet: '打印机',
    stockList: '库存报表',
    Ingredients: '关联产品',
    IsItOpen: '店铺营业',
    noIngredients: '暂无产品',
    isOut: '座位点餐-跳转到外送界面',
    IsPay: '是否先支付',
    IsSkip: '座位点餐-选择用餐人数',
    IsMerge: '按照订单打印',
    clear: '座位点餐-付款后自动清洁座位表',
    member: "会员充值",
    auto: "外卖自动打印",
    seat: "小票二维码",
  },
  SetSeat: {
    title: "设定座位",
    floor: '楼层',
    seat: '座位',
    downLoadQRcode: '全部下载',
    floorName: "楼层名称",
    submit: '提交',
    tableName: '桌名',
    inputSeatNum: "输入桌名",
    setNum: '设置人数',
    inputNum: "输入人数",
    inputSeat: "输入座位数",
    QRCode: '二维码生成区',
    message: '数据错误',
    inputFloorName: '请输入楼层名称',
    delFloor: '删除楼层',
    isDelFloor: '是否删除已选择的楼层',
    toast: '请填写完整信息',
    delSeat: '删除座位',
    isDelSeat: '是否删除当前的座位',
    pleaseInputSeatNum: '请先填写桌名',
    UsurpedRefreshQRcode: '若二维码盗用，请重新刷新',
    refresh: '刷新',
    refreshTip: '确认刷新后原QRCode将永久失效',
    savePrint: '保存此二维码，可以打印',
    download: '下载',
    copy: '复制链接'
  },
  CookInfo: {
    copy: '点击复制链接',
    loginLink: "登录链接:",
    refresh: '点击刷新二维码',
    message: '数据错误',
    copyScuess: '复制成功',
  },
  StaffList: {
    title: "员工设定",
    account: '账号:',
    message: '数据错误',
  },
  NewStaff: {
    title: "新建员工",
    name: "姓名:",
    placeholderName: "姓名",
    gender: "性别:",
    placeholdergender: "性别",
    birth: "出生日期:",
    placeholderBirth: "出生日期",
    phone: "联系电话:",
    placeholderPhone: "联系电话",
    workTime: "入职时间:",
    placeholderWorkTime: "入职时间",
    post: "岗位:",
    placeholderPost: "岗位:",
    password: "密码:",
    placeholderPassword: "密码",
    man: '男',
    woman: '女',
    staff: '服务员',
    message: '数据错误',
    toast: '请填写姓名',
  },
  EditStaff: {
    link: "登录链接:",
    copy: '复制链接',
    refresh: '刷新二维码',
    copyBtn: '复制',
    refreshBtn: '刷新',
    submit: '提交',
    delStaff: '删除员工信息',
    isDelStaff: '是否删除当前员工信息',
    success: '复制成功',
  },
  checkNum: {
    title: "验证手机号",
    text: '为了保证你的账号安全，需先验证你的身份，验证成功后可进行下一步操作',
    text2: '验证码将发送到',
    inputSMS: '输入验证码',
    SMS: 'SMS验证',
    retrieve: '秒后重新获取',
    next: '下一步',
    message: '数据错误',
    pleaseInputSMS: '请填写验证码'
  },
  UpdateNum: {
    title: "更换电话号码",
    text: '为了保证你的账号安全，新的手机号需验证',
    input: "请输入用户名或手机号",
    inputSMS: "输入验证码",
    SMS: 'SMS验证',
    retrieve: '秒后重新获取',
    certain: '确定',
    message: '数据错误',
    inputPhone: '请填写手机号码',
    fail: '验证失效',
    toast: '请填写完整信息',
  },
  ContactUs: {
    contact: '联系销售人员',
    area: '地区',
    name: '姓名',
    phone: '电话',
    hongkong: '香港',
    taiwan: '台湾',
    zhuhai: '广东珠海',
    shanwei: '广东汕尾',
    shenzhen: '广东深圳',
    shantou: '广东汕头',
    dongguan: '广东东莞',
    guilin: '广西桂林',
    fuzhou: '福建福州',
    lin: '林先生',
    tian: '佃先生',
    chan: '陈先生',
    qiu: '邱先生',
    liu: '刘先生',
    wang: '王先生',
    shi: '施先生',
    misschen: '陈小姐'
  },
  CookTime: {
    title: "制作时间",
    text1: '从',
    text: '至',
    longTime: '最长时间',
    name: '名称',
    time: '时间',
    averageTime: '平均时间',
    shortTime: '最短时间',
  },
  CustomerTime: {
    title: "客量报告",
    text1: '从',
    text: '至',
    time: '时间',
    t: '时',
    peoopleNum: '人数',
    people: '人',
    num: '数量',
  },
  DayReport: {
    export: "导出",
    title: "日销售报表",
    dateTime: "日期:",
    ticket: "流水号",
    num: "桌号",
    peoopleNum: '人数',
    price: '金额',
    people: '人',
    none: '今日没有订单',
  },
  StockReport: {
    title: "月库存报表",
    yTitle: "年库存报表",
    dTitle: '日库存报表',
    y: '年',
    d: '日'
  },
  MonthDetail: {
    month: '月',
    date: '日期',
    peoopleNum: '人数',
    price: '金额',
    day: '日',
    people: '人',
  },
  MonthReport: {
    title: "月销售报表",
    month: '月',
    m: '月',
    peoopleNum: '人数',
    price: '金额',
    money: '金额(/千)'
  },
  StaffReport: {
    title: "员工报表",
    text1: '从',
    text: '至',
    reserve: '预订',
    rank: '排名',
    name: '姓名',
    num: '数量',
    one: '单',
    order: "下单",
    dishes: "上菜",
    clean: "打扫",
    settleAccounts: "结账",
    type: '类型',
    out: '出库',
    enter: '入库'
  },
  TableRank: {
    title: "桌位排行",
    text1: '从',
    text: '至',
    amountOfMoney: "金额",
    peoopleNum: '人数',
    people: '人',
    rank: '排名',
    num: "桌号",
    price: '价格',
    amount: '数量',
  },
  WeekDetail: {
    text: '第',
    week: '周',
    date: '日期',
    amountOfMoney: "金额",
    peoopleNum: '人数',
    people: '人',
    weekReport: '周销售报表',
    day: '天',
    money: '金额(/千)',
    prev: '上一周',
    next: '下一周',
  },
  WeekReport: {
    title: "周销售报表",
    weeks: '周数',
    weekday: '日期',
    peoopleNum: '人数',
    amountOfMoney: "金额",
    money: '金额(/千)',
  },
  payMethod: {
    method: '支付方式',
    card: '信用卡',
    cash: '现金',
    other: '其他',
    totalprice: '总金额',
  },
  Login: {
    title: "灵活 · 轻便 · 省时的点菜系统",
    account: "请输入账号或手机号",
    password: "请输入密码",
    login: '登录',
    forgetPassword: '忘记密码?',
    register: '注册',
    p1: "只需要一名员工一天的工资",
    p2: "只需要一顿饭的时间设定即可使用",
    p3: "提升餐馆运作效率 增加营业额",
    p4: "第一步设定餐桌和菜品",
    p5: "第二步让员工用手机打开网页使用",
    p6: "第三步开始营业",
    p7: "陈老板：用了这个系统，省了2个员工的工资，太爽了！",
    p8: "服务员小李：客户下单结账更清晰，没有给老板骂了",
    p9: "王大厨：客户越来越多，都忙不过来了",
    p10: "现在就联系我们的销售人员，还可以享受额外的优惠哦！",
    contactUs: '联系我们',
    toast: '请输入手机号和密码！',
    title1: '便捷点',
    title2: '扫码点餐',
    title3: '自动出单',
    title4: '将餐饮管理化繁为简',
    intro1: '注册便捷点即可线上点餐，少了电话接单的手忙脚乱，订单明细清晰明确。',
    intro2: '用便捷点扫码即可扫码点餐，减少服务人力，完成智慧便捷点餐。',
    intro3: '24小时云端自动出单，不怕漏单，新订单会直接打印。',
    intro4: '免APP！完整的O2O整合！单品销售分析！实时查看店铺状态！整合多元行动支付，24小时接单不断！透过丰富的方案组合及齐全的功能，便捷点功能无可比拟，让您更轻松管理您的餐饮业务。',
  },
  ForgetPassword: {
    title: "忘记密码",
    areaName: "区号选择",
    inputPhone: "请输入手机号",
    SMS: 'SMS认证',
    inputSMS: "输入验证码",
    setNewPassword: "设置新密码",
    certainPassword: "确认新密码",
    submit: '提交',
    inputAreaNameAndPhone: '请输入区号和手机号码！',
    getSMSkey: '请先获取验证码',
    toast: '请填写完整信息',
    message: '数据错误',
    repasswordJudge: '密码不一致'
  },
  Register: {
    title: "注册",
    name: "用户名",
  },
  phoneList: {
    title: '电话号码列表',
    name: '姓名',
    phone: '电话号码',
    noPhone: '没有电话号码'
  },
  CustomerList: {
    title: '客户列表',
    noCustomer: '没有客户',
  },
  Pay: {
    type: '支付类型',
    selectType: '请选择支付类型',
    id: '应用id',
    inputId: '请输入您的应用id',
    secret: '密钥',
    inputSecret: '请输入您的密钥',
    code: '商店代码',
    inputCode: '请输入您的商店代码',
    file: '商户私钥文件',
    delete: '删除支付方式',
    isDelete: '是否删除当前支付方式',
    create: '创建支付方式',
  },
  bindCode: {
    title: '绑定二维码',
    link: '链接',
    inputLink: '请输入链接',
    bind: '绑定'
  },
  printerSet: {
    name: '打印机',
    title: '打印机设置',
    order: '订单打印机',
    queue: '排队打印机',
    kitchen: '后厨打印机',
    printerBrand: '打印机品牌',
    printerSN: '打印机编号',
    printerKey: '打印机识别码',
    testPrint: '测试打印',
    testTip: '请先添加打印机！',
    merge: '是否合并打印',
    del: '删除',
    isDelPrint: '是否删除该打印机',
    ptitle: '标题',
    remark: '备注',
    tagTitle: '样式标签',
    startlabel: '开始字符',
    endlabel: '结束字符',
  },
  print: {
    name: '打印样式',
    kitchen: '后厨单',
    cash: '收银单',
    order: '结账单',
    handover: '交接班',
    addmenu: '加菜单',
    title: '标题',
    stand: '台位',
    number: '单号',
    forHere: '堂食',
    packUp: '打包',
    takeOut: '外卖',
  },
  order: {
    title: '订单详情',
    ticket: '取餐码',
  },
  platform: {
    platformSearch: '搜索平台',
    addPlatform: '创建平台资料',
    editPlatform: '编辑平台资料',
    deleteP: '删除平台资料',
    isDeleteP: '是否刪除當前平台资料',
    image: '店铺图片',
    code: '二维码',
    platCode: '平台二维码',
    platLink: '平台链接',
    link: '链接',
    address: '地区附加费',
    createAdd: '创建地区附加费',
    editAdd: '编辑地区附加费',
    delete: '删除地区附加费',
    itemInfo: '库存管理',
    isDelete: '是否刪除當前地区附加费',
    name: '名称',
    platname: '平台名称',
    platImage: '平台图片',
    price: '价格',
    inputPlatName: '请输入平台名称',
    inputName: '请输入名称',
    inputPrice: '请输入价格',
    inputLink: '请输入链接',
    platInputLink: '请输入平台链接',
    successtips: '复制成功',
    errtips: '该浏览器不支持自动复制',
    warehousing: '入库列表',
    issueList: '出库列表',
    receiptSet: '收货人讯息',
    shopList: '店铺列表',
    ForceSurcharge: '强制地区附加费',
  },
  itemInfo: {
    name: '物品名称',
    number: '物品数量',
    company: '物品单位',
    exWarehouse: '出库',
    exWarehouseReason: '出库原因',
    warehousing: '入库',
    inputName: '请输入物品名称',
    inputNumber: '请输入物品数量',
    successMsg: '添加成功',
    editSuccessMsg: '编辑成功',
    time: '时间',
    operation: '操作',
    deleteP: '删除物品信息',
    isDeleteP: '是否删除当前物品信息',
    successDelMsg: '删除成功',
    price: '物品价格',
    inputPrice: '请输入物品价格',
    qualityDate: '保质期',
    date: '日期',
    exSuccess: '出库成功',
    waSuccess: '入库成功',
    overdue: '过期',
    consume: '消耗',
    unitTitle: '物品单位',
    addUnit: '新增单位',
    editUnit: '编辑单位',
    unitName: '单位名称',
    unitsymbol: '单位符号',
    unitInputName: '请输入单位名称',
    unitInputsymbol: '请输入单位符号',
    deleteUnitP: '删除单位',
    isDeleteUnitP: '是否删除当前单位信息',
    nodatamsg: '暂无数据，请去物品单位表添加',
    barCode: '条形码',
    find: '查看',
    itemdetail: '详情',
  },
  tax: {
    name: "税费",
    add: "添加",
    delete: "删除",
    PleaseTaxName: "请输入税名",
    PleaseTaxPrice: "请输入税率",
  },
  invoice: {
    titile: "发票资料",
    pleaseInput: "请输入",
    unifiedNumber: "统一编号",
    postMachineCode: "post机码",
    postMachineSerialNumber: "post机序号",
    productName: "产品名称",
    Authenticator: "认证码",
    StoreCode: "门市编码",
  }
}



// WEBPACK FOOTER //
// ./src/assets/common/lang/zh.js